import React from "react";
import './Share.css'
import {
    EmailShareButton,
    FacebookShareButton,
    HatenaShareButton,
    InstapaperShareButton,
    LineShareButton,
    LinkedinShareButton,
    LivejournalShareButton,
    MailruShareButton,
    OKShareButton,
    PocketShareButton,
    RedditShareButton,
    TelegramShareButton,
    TumblrShareButton,
    TwitterShareButton,
    ViberShareButton,
    WhatsappShareButton,
    WorkplaceShareButton
} from "react-share";
import {
    EmailIcon,
    FacebookIcon,
    HatenaIcon,
    InstapaperIcon,
    LineIcon,
    LinkedinIcon,
    LivejournalIcon,
    MailruIcon,
    OKIcon,
    PocketIcon,
    RedditIcon,
    TelegramIcon,
    TumblrIcon,
    TwitterIcon,
    ViberIcon,
    WhatsappIcon,
    WorkplaceIcon
} from "react-share";


const Share = (props) => {

    const { shareUrl, title } = props;

    return (
        <div className="Share__container">
            <div className="Share__some-network">
                <FacebookShareButton
                    url={shareUrl}
                    quote={title}
                    className="Share__some-network__share-button"
                >
                    <FacebookIcon size={32} round />
                </FacebookShareButton>

            </div>

            <div className="Share__some-network">
                <TwitterShareButton
                    url={shareUrl}
                    title={title}
                    className="Share__some-network__share-button"
                >
                    <TwitterIcon size={32} round />
                </TwitterShareButton>
            </div>

            <div className="Share__some-network">
                <TelegramShareButton
                    url={shareUrl}
                    title={title}
                    className="Share__some-network__share-button"
                >
                    <TelegramIcon size={32} round />
                </TelegramShareButton>
            </div>

            <div className="Share__some-network">
                <WhatsappShareButton
                    url={shareUrl}
                    title={title}
                    separator=":: "
                    className="Share__some-network__share-button"
                >
                    <WhatsappIcon size={32} round />
                </WhatsappShareButton>
            </div>

            <div className="Share__some-network">
                <LinkedinShareButton url={shareUrl} className="Share__some-network__share-button">
                    <LinkedinIcon size={32} round />
                </LinkedinShareButton>
            </div>

            <div className="Share__some-network">
                <OKShareButton
                    url={shareUrl}
                    className="Share__some-network__share-button"
                >
                    <OKIcon size={32} round />
                </OKShareButton>
            </div>

            <div className="Share__some-network">
                <RedditShareButton
                    url={shareUrl}
                    title={title}
                    windowWidth={660}
                    windowHeight={460}
                    className="Share__some-network__share-button"
                >
                    <RedditIcon size={32} round />
                </RedditShareButton>

            </div>

            <div className="Share__some-network">
                <TumblrShareButton
                    url={shareUrl}
                    title={title}
                    className="Share__some-network__share-button"
                >
                    <TumblrIcon size={32} round />
                </TumblrShareButton>

            </div>

            <div className="Share__some-network">
                <LivejournalShareButton
                    url={shareUrl}
                    title={title}
                    description={shareUrl}
                    className="Share__some-network__share-button"
                >
                    <LivejournalIcon size={32} round />
                </LivejournalShareButton>
            </div>

            <div className="Share__some-network">
                <MailruShareButton
                    url={shareUrl}
                    title={title}
                    className="Share__some-network__share-button"
                >
                    <MailruIcon size={32} round />
                </MailruShareButton>
            </div>

            <div className="Share__some-network">
                <EmailShareButton
                    url={shareUrl}
                    subject={title}
                    body="body"
                    className="Share__some-network__share-button"
                >
                    <EmailIcon size={32} round />
                </EmailShareButton>
            </div>
            <div className="Share__some-network">
                <ViberShareButton
                    url={shareUrl}
                    title={title}
                    className="Share__some-network__share-button"
                >
                    <ViberIcon size={32} round />
                </ViberShareButton>
            </div>

            <div className="Share__some-network">
                <WorkplaceShareButton
                    url={shareUrl}
                    quote={title}
                    className="Share__some-network__share-button"
                >
                    <WorkplaceIcon size={32} round />
                </WorkplaceShareButton>
            </div>

            <div className="Share__some-network">
                <LineShareButton
                    url={shareUrl}
                    title={title}
                    className="Share__some-network__share-button"
                >
                    <LineIcon size={32} round />
                </LineShareButton>
            </div>

            <div className="Share__some-network">
                <PocketShareButton
                    url={shareUrl}
                    title={title}
                    className="Share__some-network__share-button"
                >
                    <PocketIcon size={32} round />
                </PocketShareButton>
            </div>

            <div className="Share__some-network">
                <InstapaperShareButton
                    url={shareUrl}
                    title={title}
                    className="Share__some-network__share-button"
                >
                    <InstapaperIcon size={32} round />
                </InstapaperShareButton>
            </div>

            <div className="Share__some-network">
                <HatenaShareButton
                    url={shareUrl}
                    title={title}
                    windowWidth={660}
                    windowHeight={460}
                    className="Share__some-network__share-button"
                >
                    <HatenaIcon size={32} round />
                </HatenaShareButton>

            </div>
        </div>
    );
}

export default Share;